'use strict';

/** Import AjaxHandler class */
import AjaxHandler from '../utility/ajax_handler/ajax_handler';

/**
 * @class Pagination
 */
class Pagination
{
    /**
     * @param options
     * @constructor
     */
    constructor (options)
    {
        if (!options || !options.url )
        {
            throw TypeError('Pagination api url must be set in option parameters');
        }

        this._defaultData = {};
        this._defaultData.url = options.url;
        this._defaultData.additionalFilters = (options.hasOwnProperty('additionalFilters')) ? options.additionalFilters : [];
        this._defaultData.responseCallbacks = (options.hasOwnProperty('responseCallbacks')) ? options.responseCallbacks : [];
        this._defaultData.activeStatistic = (options.hasOwnProperty('activeStatistic')) ? options.activeStatistic : false;

        this._json = null;
        this._currentPage = 1;

        this._appPagination = $('#app-pagination');
        this._paginationResultContainer = this._appPagination.find('#app-pagination-result-container');

        this._paginationEntries = this._appPagination.find('.app-pagination-entries');
        this._paginationCurrentPage = this._appPagination.find('.app-pagination-page');
        this._paginationPrevious = this._appPagination.find('.app-pagination-previous');
        this._paginationNext = this._appPagination.find('.app-pagination-next');

        this._paginationConfig = this._appPagination.data('app-pagination-config');
        this._paginationType = this._paginationConfig.type;

        this._loadJsonObj();
        this._listenPaginationEntries();
        this._listenPaginationPrev();
        this._listenPaginationNext();

        if (this._paginationType === 'table_pagination')
        {
            this._paginationTableSearch = this._appPagination.find('#app-pagination-table-search');
            this._paginationTableColumns = this._appPagination.find('th');
            this._listenPaginationTableSearch();
            this._listenSortColumn();
        }

        if (this._paginationType === 'block_pagination')
        {
            this._paginationSortDropDown = this._appPagination.find('.app-pagination-sort-dropdown');
            this._paginationTotalPages = this._appPagination.find('.app-pagination-total-pages');
            this._paginationTotal = this._appPagination.find('.app-pagination-total');
            this._paginationShowingResults = this._appPagination.find('.app-pagination-showing-results');
            this._listenSortDropDown();
        }

        this._listenAdditionalFilters();
        this._init();
    }

    /**
     * @param data
     */
    triggerPaginationWithData (data)
    {
        let that = this;
        that._json.lastId = that._getRowsPerPage() + 1;
        if (data)
        {
            $.extend(that._json, data);
            that._currentPage = (that._json.firstId / (that._json.lastId - 1)) + 1;
            that._paginationEntries.val(that._json.lastId - 1);

            if (that._paginationType === 'block_pagination')
            {
                let selected = (that._json.sortColumn) ? that._json.sortColumn + '-' + that._json.sortDirection : '';
                that._paginationSortDropDown.val(selected);
            }

            if (that._paginationType === 'table_pagination')
            {
                that._paginationTableSearch.val(that._json.search);
                that._unsetSortArrows();
                $.each(that._paginationTableColumns, (k, v) =>
                {
                    let column = $(v).data('column');
                    if (column && column === that._json.sortColumn)
                    {
                        let span = $(v).next().find('span');
                        that._setSortArrow(span);
                    }
                });
            }
        }
        that._load();
    }

    /**
     * @private
     */
    _init ()
    {
        let that = this;
        that._json.lastId = that._getRowsPerPage() + 1;
        that._loadAdditionalFiltersValues();
        that._load();
    }

    /**
     * @private
     */
    _loadAdditionalFiltersValues ()
    {
        if (this._defaultData.additionalFilters.length > 0)
        {
            $.each(this._defaultData.additionalFilters, (a, b) =>
            {
                switch (b.type)
                {
                    case 'range':
                        this._json[b.key.from] = b.default;
                        this._json[b.key.to] = b.default;
                        break;
                    case 'link':
                        let links = $(b.selector);
                        $.each(links, (c, d) =>
                        {
                            if ($(d).data('selected') === true)
                            {
                                this._json[b.key] = (parseInt($(d).data(b.key.toLowerCase())) > 0) ? $(d).data(b.key.toLowerCase()) : b.default;
                            }
                        });
                        break;
                    default:
                        this._json[b.key] = ($(b.selector).val()) ? $(b.selector).val() : b.default;
                        break;
                }
            });
        }
    }

    /**
     * @private
     */
    _listenAdditionalFilters ()
    {
        let that = this;
        if (that._defaultData.additionalFilters.length > 0)
        {
            $.each(that._defaultData.additionalFilters, (k, v) =>
            {
                $(v.selector).on(v.event, (e) =>
                {
                    let val;
                    switch (v.type)
                    {
                        case 'link':
                            that._json[v.key] = v.default;
                            val = $(e.target).data(v.key.toLowerCase());
                            break;
                        case 'range':
                            that._json[v.key.from] = v.default;
                            that._json[v.key.to] = v.default;
                            val = $(v.key.range).val();
                            break;
                        default:
                            that._json[v.key] = v.default;
                            val = $(e.target).val();
                            break;
                    }

                    let trigger = (!(v.event === 'keyup' && (val.length === 1 || val.length === 2)));

                    if (trigger)
                    {
                        that._json.activeQueryStatistic = (that._defaultData.activeStatistic && !v.deactiveStatistic);
                        if (val && v.type && v.type === 'range')
                        {
                            that._json[v.key.from] = val.split('-')[0];
                            that._json[v.key.to] = val.split('-')[1];
                        } else {
                            that._json[v.key] = val;
                        }
                        that._resetToFirstPage();
                        that._load();
                    }
                });
            });
        }
    }

    /**
     * @private
     */
    _listenPaginationEntries ()
    {
        let that = this;
        that._paginationEntries.on('change', (e) =>
        {
            let selected = parseInt($(e.target).val());
            that._paginationEntries.val(selected);
            that._json.activeQueryStatistic = true;
            that._json.lastId = selected + 1;
            that._resetToFirstPage();
            that._load();
        })
    }

    /**
     * @private
     */
    _listenPaginationTableSearch ()
    {
        let that = this;
        that._paginationTableSearch.on('keyup', () =>
        {
            if (that._paginationTableSearch.val().length > 2 || that._paginationTableSearch.val().length === 0)
            {
                that._json.activeQueryStatistic = that._defaultData.activeStatistic;
                that._json.search = that._paginationTableSearch.val();
                that._resetToFirstPage();
                that._load();
            }
        });
    }

    /**
     * @private
     */
    _listenPaginationPrev ()
    {
        let that = this;
        that._paginationPrevious.on('click', (e) =>
        {
            $(e.target).blur();
            that._currentPage--;
            that._json.activeQueryStatistic = false;
            that._json.firstId = (that._currentPage - 1) * that._getRowsPerPage();
            that._load();
        });
    }

    /**
     * @private
     */
    _listenPaginationNext ()
    {
        let that = this;
        that._paginationNext.on('click', (e) =>
        {
            $(e.target).blur();
            that._json.activeQueryStatistic = false;
            that._json.firstId = that._currentPage * that._getRowsPerPage();
            that._currentPage++;
            that._load();
        });
    }

    /**
     * @private
     */
    _listenSortDropDown ()
    {
        let that = this;
        that._paginationSortDropDown.on('change', (e) =>
        {
            let sortData = $(e.target).val().split('-');
            that._json.activeQueryStatistic = false;
            that._json.sortColumn = sortData[0];
            that._json.sortDirection = sortData[1];
            that._resetToFirstPage();
            that._load();
        });
    }

    /**
     * @private
     */
    _listenSortColumn ()
    {
        let that = this;
        that._paginationTableColumns.on('click', (e) =>
        {
            let column = ($(e.target).data('column')) ? $(e.target).data('column') : $(e.target).prev().data('column');
            if (column)
            {
                that._json.activeQueryStatistic = false;
                that._unsetSortArrows();
                let span = ($(e.target).data('column')) ? $(e.target).next().find('span') : $(e.target).find('span');
                that._setSortDirection(column);
                that._resetToFirstPage();
                that._setSortArrow(span);
                that._load();
            }
        });
    }

    /**
     * @private
     */
    _unsetSortArrows ()
    {
        this._paginationTableColumns.find('span').removeClass('fa-caret-up').removeClass('fa-caret-down');
    }

    /**
     * @param column
     * @private
     */
    _setSortDirection (column)
    {
        if (!this._json.sortColumn || this._json.sortColumn !== column)
        {
            this._json.sortColumn = column;
            this._json.sortDirection = 'ASC';

        } else {
            switch (this._json.sortDirection)
            {
                case 'ASC':
                    this._json.sortDirection = 'DESC';
                    break;
                case 'DESC':
                    this._json.sortColumn = null;
                    this._json.sortDirection = null;
                    break;
                default:
                    this._json.sortDirection = 'ASC';
                    break;
            }
        }
    }

    /**
     * @param span
     * @private
     */
    _setSortArrow (span)
    {
        switch (this._json.sortDirection)
        {
            case 'ASC':
                span.addClass('fa-caret-up');
                break;
            case 'DESC':
                span.addClass('fa-caret-down');
                break;
            default:
                span.removeClass('fa-caret-up').removeClass('fa-caret-down');
                break;
        }
    }

    /**
     * @private
     */
    _load ()
    {
        this._setCurrentPage();
        this._xhrCall();
    }

    /**
     * @private
     */
    _xhrCall ()
    {
        let that = this;
        AjaxHandler.post(that._defaultData.url, that._json).then(response =>
        {
            that._paginationResultContainer.html(response.content);

            if (that._paginationType === 'table_pagination')
            {
                that._paginationPrevious.prop('disabled', (that._currentPage < 2));
                that._paginationNext.prop('disabled', response.isLast);
            }

            if (that._paginationType === 'block_pagination')
            {
                (that._currentPage < 2) ? that._paginationPrevious.addClass('hidden') : that._paginationPrevious.removeClass('hidden');
                (response.isLast) ? that._paginationNext.addClass('hidden') : that._paginationNext.removeClass('hidden');

                that._paginationShowingResults.html(response.showing);

                if (response.statistic)
                {
                    if (response.statistic.total)
                    {
                        that._paginationTotal.html('of ' + response.statistic.total);
                    }

                    if (response.statistic.totalPages)
                    {
                        that._paginationTotalPages.html(response.statistic.totalPages);
                    }
                }
            }

            if (that._defaultData.responseCallbacks.length > 0)
            {
                $.each(that._defaultData.responseCallbacks, (k, v) =>
                {
                    v(response);
                });
            }
        });
    }

    /**
     * @private
     */
    _resetToFirstPage ()
    {
        this._json.firstId = 0;
        this._currentPage = 1;
    }

    /**
     * @private
     */
    _setCurrentPage ()
    {
        this._paginationCurrentPage.html(this._currentPage);
    }

    /**
     * @returns {number}
     * @private
     */
    _getRowsPerPage ()
    {
        return parseInt(this._paginationEntries.val());
    }

    /**
     * @private
     */
    _loadJsonObj ()
    {
        let json = this.constructor._getCleanJsonObj();
        if (this._paginationType === 'block_pagination')
        {
            delete json.search;
        }
        if (this._defaultData.activeStatistic)
        {
            json.activeQueryStatistic = true;
        }
        json.fieldsData = this._paginationConfig;
        this._json = json;
    }

    /**
     * @returns {{fieldsData: Array, firstId: number, lastId: number, search: null, sortColumn: null, sortDirection: null}}
     * @private
     */
    static _getCleanJsonObj ()
    {
        return {
            activeQueryStatistic: false,
            fieldsData: [],
            firstId: 0,
            lastId: 0,
            search: null,
            sortColumn: null,
            sortDirection: null
        }
    }
}

/** @export Pagination */
export default Pagination;


// WEBPACK FOOTER //
// ./assets/js/shared/pagination/pagination.js